var render = function render(){var _vm=this,_c=_vm._self._c;return _c('tg-tool-layout',[(_vm.isMobile)?void 0:[_c('tg-date-search',{attrs:{"showDateRangePicker":""},model:{value:(_vm.dateRange),callback:function ($$v) {_vm.dateRange=$$v},expression:"dateRange"}})]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }